import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors, THEME_OPTIONS } from '../theme'
import Header from './Header'
import Footer from './Footer'

export default function About({ theme = THEME_OPTIONS.LIGHT, session = null }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 900 : false))
  const teamImage = '/team.jpeg'

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const sectionStyle = {
    background: C.white,
    border: `0.5px solid ${C.border}`,
    borderRadius: '18px',
    padding: '24px',
    boxShadow: C.shadow,
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif", overflowX: 'hidden' }}>
      <Header theme={theme} session={session} perfil={null} />

      <div style={{ maxWidth: '1080px', margin: '0 auto', padding: isMobile ? '16px' : '32px', boxSizing: 'border-box' }}>
        <div style={{ ...sectionStyle, padding: isMobile ? '20px' : '36px', marginBottom: '18px', overflow: 'hidden' }}>
          <div style={{ fontSize: '11px', color: C.blue, textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: '600', marginBottom: '10px' }}>
            Sobre nosotros
          </div>
          {session && (
            <button
              onClick={() => navigate('/dashboard')}
              style={{ marginBottom: '14px', padding: '8px 12px', background: C.blueLight, color: C.blue, border: `0.5px solid ${C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}
            >
              Volver al dashboard
            </button>
          )}
          <div style={{ fontSize: isMobile ? '30px' : '40px', fontWeight: '500', letterSpacing: '-1.2px', lineHeight: '1.05', maxWidth: '720px', marginBottom: '14px' }}>
            Buscar trabajo no deberia ser un trabajo
          </div>
          <div style={{ fontSize: '15px', color: C.muted, lineHeight: '1.8', maxWidth: '720px' }}>
            JobPipeline nace de una frustracion real: demasiadas horas revisando portales, demasiadas vacantes irrelevantes y demasiado esfuerzo para encontrar oportunidades que si hagan sentido.
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1.15fr 0.85fr', gap: '18px', marginBottom: '18px' }}>
          <div style={sectionStyle}>
            <div style={{ fontSize: '22px', fontWeight: '500', marginBottom: '12px' }}>Todo empezo con una frustracion</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '14px' }}>
              Buscar trabajo se volvio un trabajo en si mismo.
            </div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '14px' }}>
              Horas revisando portales.<br />
              Decenas de vacantes irrelevantes.<br />
              Aplicaciones sin respuesta.
            </div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              No era falta de oportunidades. Era ruido. Y demasiado.
            </div>
          </div>

          <div style={sectionStyle}>
            <img
              src={teamImage}
              alt="Equipo JobPipeline"
              onError={(e) => { e.currentTarget.style.display = 'none' }}
              style={{ width: '100%', borderRadius: '14px', display: 'block', marginBottom: '14px', border: `0.5px solid ${C.border}` }}
            />
            <div style={{ fontSize: '12px', color: C.blue, fontWeight: '600', marginBottom: '8px' }}>
              Narevya
            </div>
            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
              Narevya no es un chatbot. Es la operadora silenciosa de JobPipeline: trabaja por ti, aparece cuando agrega valor y pone primero las oportunidades que realmente valen la pena.
            </div>
            <div style={{ fontSize: '11px', color: C.subtle, lineHeight: '1.7', marginTop: '10px' }}>
              Visual identity © acuneo
            </div>
          </div>
        </div>

        <div style={{ ...sectionStyle, marginBottom: '18px' }}>
          <div style={{ fontSize: '22px', fontWeight: '500', marginBottom: '12px' }}>
            Entonces hicimos lo que cualquier persona practica haria
          </div>
          <div style={{ fontSize: '18px', color: C.blue, fontWeight: '500', marginBottom: '12px' }}>
            Lo automatizamos.
          </div>
          <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', maxWidth: '820px' }}>
            Creamos un sistema que hace el trabajo pesado: buscar, filtrar, analizar y priorizar oportunidades por ti. No para mostrarte mas. Sino para mostrarte mejor.
          </div>
        </div>

        <div style={{ ...sectionStyle, marginBottom: '18px' }}>
          <div style={{ fontSize: '22px', fontWeight: '500', marginBottom: '14px' }}>Que hace diferente a esto</div>
          <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '12px' }}>
            No es otro portal de empleo.
          </div>
          <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '18px' }}>
            No estamos aqui para llenarte de opciones. Estamos aqui para delegar la busqueda contigo y ayudarte a decidir mejor.
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '14px', marginBottom: '18px' }}>
            {[
              'Se analiza su relevancia real',
              'Se compara contra tu perfil',
              'Se prioriza segun valor y contexto',
            ].map((item) => (
              <div key={item} style={{ background: C.blueLight, border: `0.5px solid ${C.border}`, borderRadius: '14px', padding: '18px', fontSize: '14px', color: C.text, lineHeight: '1.7' }}>
                {item}
              </div>
            ))}
          </div>

          <div style={{ fontSize: '15px', fontWeight: '500', color: C.text }}>
            El resultado: <span style={{ color: C.blue }}>menos ruido, mas claridad, mejores decisiones.</span>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '18px', marginBottom: '18px' }}>
          <div style={sectionStyle}>
            <div style={{ fontSize: '22px', fontWeight: '500', marginBottom: '12px' }}>Quien esta detras</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '12px' }}>
              Detras de esto no hay una startup generica.
            </div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '12px' }}>
              Hay experiencia real en proyectos, banca y tecnologia. Personas que han estado del otro lado del proceso.
            </div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Sabemos como se ven las vacantes de verdad. Sabemos que filtrar. Y sabemos que si vale la pena.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '22px', fontWeight: '500', marginBottom: '12px' }}>Quien es Narevya</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '12px' }}>
              Narevya no te interrumpe, no te explica de mas y no te hace perder tiempo.
            </div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9', marginBottom: '12px' }}>
              Su trabajo es buscar, filtrar, priorizar y aprender de tus decisiones para que tu solo veas oportunidades con contexto y claridad.
            </div>
            <div style={{ fontSize: '15px', fontWeight: '500', color: C.blue }}>
              Directa. Silenciosa. Proactiva.
            </div>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)', gap: '18px', marginBottom: '18px' }}>
          {[
            {
              title: 'Buscar trabajo no deberia consumir tu vida',
              text: 'La herramienta debe devolverte tiempo, no quitartelo.',
            },
            {
              title: 'Mas opciones no significa mejores oportunidades',
              text: 'Cantidad sin criterio normalmente solo agrega ruido.',
            },
            {
              title: 'La claridad es mas valiosa que el volumen',
              text: 'Primero entender que importa; despues actuar.',
            },
            {
              title: 'Aplicar con intencion siempre gana',
              text: 'Decidir mejor vale mas que aplicar por inercia.',
            },
          ].map((item) => (
            <div key={item.title} style={sectionStyle}>
              <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '10px' }}>{item.title}</div>
              <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>{item.text}</div>
            </div>
          ))}
        </div>

        <div style={{ ...sectionStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '6px' }}>Empieza a ver oportunidades que si hacen sentido</div>
            <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.7' }}>
              Deja de perder tiempo. Empieza a avanzar.
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button onClick={() => navigate('/login')} style={{ padding: '12px 18px', background: C.blue, color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
              Probar ahora
            </button>
            <button onClick={() => navigate('/feedback')} style={{ padding: '12px 18px', background: C.white, color: C.blue, border: `0.5px solid ${C.blue}`, borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
              Feedback y contacto
            </button>
          </div>
        </div>

        <Footer theme={theme} />
      </div>
    </div>
  )
}
